module.exports = __webpack_public_path__ + "img/iqala_logo.0b723cfc.svg";